/**
 * The editor's Save, reachable from deep inside its tabs (user, 13/10/2026:
 * "on the optimiser we should have a save button without quitting the
 * pop-up"). The drawer provides it; an optimizer window shows a Save button
 * when it is there and nothing otherwise (a window rendered outside the
 * drawer — specs — keeps its Done alone).
 * For Media Devoted | Created By Ciro Autiero
 */
import { createContext, useContext } from 'react';

export interface EditorSave {
  /** "Save container" / "Save master config". */
  label: string;
  dirty: boolean;
  saving: boolean;
  /** Why the draft cannot be saved yet (the header's own reason), else null. */
  invalidReason: string | null;
  /** The header's Save — with its confirmations (auto-send switching on). */
  save: () => void;
}

const EditorSaveContext = createContext<EditorSave | null>(null);

export const EditorSaveProvider = EditorSaveContext.Provider;

export const useEditorSave = (): EditorSave | null => useContext(EditorSaveContext);
